import { LanguageEnum } from 'js/src/client';
import { getVideoLanguage } from 'js/src/data/app';
import { shouldSeparateWordsWithSpaces } from 'js/src/data/translations';
import type { RootState } from 'js/src/libs/RootState';

/**
 * Whether text auto-fitting should be allowed to break words, based on the video's language.
 *
 * Languages that don't separate words with spaces (Chinese, Japanese, Thai) arrive as a single
 * unbreakable "word", so fitting them with word-breaking off caps the size at whatever fits the
 * whole run on one line instead of wrapping across the lines the text box actually has room for.
 * Callers that fit or auto-shrink text (`getFontSizeToFitAllText` / `setFontSizeToFitAllText`)
 * should pass this so those languages fit against the box's real capacity.
 */
export const getShouldWordBreakForVideoLanguage = (state: RootState): boolean =>
    !shouldSeparateWordsWithSpaces(state, getVideoLanguage(state) ?? LanguageEnum.XX);
